






























































































































































import { Prop, Vue, Component } from "vue-property-decorator";
import {
  getBookSubjectListApi,
  getBookCategoryListApi,
  getBookStaffSelectListData,
  getBookStaffSelectListApi,
} from "@/api/textBook";
import { getDirectoryListApi, getHomeworkListApi } from "@/api/homework";
@Component
export default class extends Vue {
  dialogVisible = false;
  step: number = 1;
  searchInfo = {
    subject_id: "" as string | number,
    category_id: "" as string | number,
    book_title: "",
  };
  tableData: any[] = [];
  subjectList: [] = []; // 科目列表
  categoryList: [] = []; // 分类列表
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  currentBookName: string = ""; //当前选中教材名称
  currentBookContent: any[] = []; //当前选中教材下的章节
  currentSelectedHomeworkMark: string = ""; //当前选中的练习id
  currentSelectedHomeworkData: any = {}; //当前选中的练习内容
  created() {
    getBookSubjectListApi().then((res: any) => {
      this.subjectList = res.data.list;
    });
    getBookCategoryListApi().then((res: any) => {
      this.categoryList = res.data.list;
    });
  }
  showDialog() {
    this.step = 1;
    this.dialogVisible = true;
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  getList(params: { page: number; page_size: number }) {
    const option: getBookStaffSelectListData = {
      page: params.page,
      page_size: params.page_size,
    };
    if (typeof this.searchInfo.subject_id === "number") {
      option.subject_id = this.searchInfo.subject_id;
    }

    if (typeof this.searchInfo.category_id === "number") {
      option.category_id = this.searchInfo.category_id;
    }
    if (this.searchInfo.book_title) {
      option.book_title = this.searchInfo.book_title;
    }
    getBookStaffSelectListApi(option).then((res: any) => {
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.page = res.data.page;
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  selectBook(row: { book_id: number; title: string }) {
    // 教材已切换，重置已选练习
    this.currentBookContent = [];
    this.currentSelectedHomeworkMark = "";
    this.currentSelectedHomeworkData = {};
    this.currentBookName = row.title;
    getDirectoryListApi({ book_id: row.book_id }).then((res: any) => {
      res.data.list.map((item: any) => {
        item.export = false;
        item.homework_list = [];
      });
      this.currentBookContent = res.data.list;
    });
    this.step = 2;
  }
  handleChapterExport(i: number, item: any) {
    if (item.export) {
      this.currentBookContent[i].export = false;
    } else {
      this.currentBookContent[i].export = true;
      if (item.homework_list.length === 0) {
        getHomeworkListApi({ directory_id: item.book_directory_id }).then(
          (res: any) => {
            res.data.list.map((item: any) => {
              if (item.title.length > 20) {
                item.title = item.title.slice(0, 20) + "...";
              }
            });
            this.currentBookContent[i].homework_list = res.data.list;
          }
        );
      }
    }
  }
  handleHomeworkSelect(data: any) {
    this.currentSelectedHomeworkData = data;
  }
  handleClose() {
    this.currentSelectedHomeworkData = {};
    this.dialogVisible = false;
  }
  handleSubmit() {
    if (!this.currentSelectedHomeworkData.book_homework_id) {
      this.$message({
        type: "warning",
        message: "请先选择练习",
      });
      return false;
    }
    this.$emit("change", this.currentSelectedHomeworkData);
    this.dialogVisible = false;
  }
}
